import { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '../stores/auth-store';

/**
 * Admin sign-in. Uses Supabase email/password.
 *
 * No sign-up flow — admins are provisioned by setting
 * `profiles.is_social_admin=true` directly in Supabase Studio. The future
 * AdminGuard (Phase 4b) blocks composer access for non-admin users.
 */
export function LoginPage() {
  const signIn = useAuthStore((s) => s.signIn);
  const loading = useAuthStore((s) => s.loading);
  const error = useAuthStore((s) => s.error);
  const session = useAuthStore((s) => s.session);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // If the user lands on /login already signed in (refresh, bookmark, etc),
  // OR signs in successfully, jump straight to the composer. Without this,
  // the form stayed visible even after the session header flipped to
  // "Sign out" because the URL never changed off /login.
  useEffect(() => {
    if (session) navigate('/', { replace: true });
  }, [session, navigate]);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    await signIn(email, password).catch(() => {
      /* error surfaced via store */
    });
  }

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <img src="/logo-mark.svg" alt="NewsWave" className="login-logo" />
          <div>
            <div className="login-brand-name">NewsWave</div>
            <div className="login-brand-sub">Social Composer · Admin</div>
          </div>
        </div>
        <form onSubmit={onSubmit}>
          <label>
            Email
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Password
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          {error ? <div className="error">{error}</div> : null}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
